<script lang="ts" setup>
import logo from "@brand-logo-footer"
import { ref } from "vue"
import { useTranslation } from "@/composables"
import { getBrandName } from "./footer.constants"

interface FooterBrandProps {
  customLogo?: string | null
  hideGpxBrand?: boolean
  isFreemiumEvent?: boolean
}

withDefaults(defineProps<FooterBrandProps>(), { customLogo: null, hideGpxBrand: false, isFreemiumEvent: false })

const { t } = useTranslation()

const currentYear = ref(new Date().getFullYear())

const brand = getBrandName()
const brandLink = `https://${import.meta.env.VITE_BRAND || "guestpix"}.com`
</script>

<template>
  <div data-test="footer-brand">
    <div v-if="customLogo" class="gpx-brand-custom">
      <img :src="customLogo" :alt="t('footer.custom_logo_alt')">
    </div>
    <div v-if="!hideGpxBrand" class="gpx-brand">
      <a :href="brandLink">
        <img :src="logo" :alt="t('footer.logo_alt', { brand })" class="gpx-logo">
      </a>
      <div class="text-xs my-2 text-gray-700">
        {{ t("footer.powered_by", { currentYear }) }} <span v-if="isFreemiumEvent">- {{ t('footer.free_tier') }}</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.gpx-brand {
  display: flex;
  flex-direction: column;
}

.gpx-brand img {
  max-width: 10rem;
}

.gpx-brand-custom img {
  max-width: 20rem;
  max-height: 8rem;
}

@media (width <= 768px) {
  .gpx-brand {
    flex-direction: column-reverse;
  }

  .gpx-brand-custom {
    display: flex;
    justify-content: center;
  }

  .gpx-brand-custom img {
    max-width: 70%;
  }
}
</style>
